// removed by extract-text-webpack-plugin
module.exports = {"TwoButtonDialog":"TwoButtonDialog--1d9El","Info":"Info--1eiuE","ButtomToolbar":"ButtomToolbar--35zYg"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Dialogs/TwoButtonDialog/TwoButtonDialog.scss
// module id = 942
// module chunks = 1